import api from "@helpers/api";

/**
 * Delete a material
 * @param {string|number} materialId - Material ID to delete
 * @returns {Promise<{success: boolean, error?: string}>}
 */
export async function deleteMaterial(materialId) {
    try {
        const { data } = await api.delete(`material/${materialId}`);

        return { success: true, data };
    } catch (error) {
        console.error('Error deleting material:', error);

        return {
            success: false,
            error: 'Um erro ocorreu ao deletar o material, tente novamente mais tarde'
        };
    }
}
